import { render, staticRenderFns } from "./CeaseAndDesistWidget.vue?vue&type=template&id=81953962&"
import script from "./CeaseAndDesistWidget.vue?vue&type=script&lang=ts&"
export * from "./CeaseAndDesistWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports